
import { Department, Unit, Employee, Shift, Device, Role, EmployeeStatus, AttendanceRecord, LeaveRequest, LeaveType, Holiday, Location } from './types';

export const LOCATIONS: Location[] = [
  { id: 'loc1', name: 'Merkez Ofis', address: 'Teknoloji Cad. No:123, Maslak, İstanbul', type: 'OFFICE' },
  { id: 'loc2', name: 'Doğu Lojistik Merkezi', address: 'Lojistik Yolu Bulvarı No:456, Tuzla, İstanbul', type: 'WAREHOUSE' },
];

export const DEPARTMENTS: Department[] = [
  { id: 'd1', name: 'Mühendislik', managerId: 'e1', description: 'Yazılım ve Donanım geliştirme' },
  { id: 'd2', name: 'İnsan Kaynakları', managerId: 'e3', description: 'Personel ve İşe Alım' },
  { id: 'd3', name: 'Operasyon', description: 'Lojistik ve Günlük Operasyonlar' },
];

export const UNITS: Unit[] = [
  { id: 'u1', departmentId: 'd1', name: 'Frontend Geliştirme' },
  { id: 'u2', departmentId: 'd1', name: 'Backend Geliştirme' },
  { id: 'u3', departmentId: 'd2', name: 'İşe Alım' },
  { id: 'u4', departmentId: 'd3', name: 'Lojistik' },
];

export const SHIFTS: Shift[] = [
  { id: 's1', name: 'Standart Gündüz', startTime: '09:00', endTime: '18:00', toleranceEntry: 15, toleranceExit: 0, breakDuration: 60 },
  { id: 's2', name: 'Erken Mesai', startTime: '07:00', endTime: '16:00', toleranceEntry: 10, toleranceExit: 0, breakDuration: 60 },
  { id: 's3', name: 'Gece Vardiyası', startTime: '14:00', endTime: '23:00', toleranceEntry: 30, toleranceExit: 0, breakDuration: 45 },
];

export const EMPLOYEES: Employee[] = [
  {
    id: 'e1',
    firstName: 'Sarah',
    lastName: 'Connor',
    email: 'sarah.c@nexus.com',
    phone: '+90 555 0101',
    departmentId: 'd1',
    unitId: 'u1',
    role: Role.ADMIN,
    status: EmployeeStatus.PERMANENT,
    position: 'Teknoloji Lideri',
    hireDate: '2020-01-15',
    salary: 85000,
    shiftId: 's1',
    clothingSize: 'M',
    documents: ['Sozlesme.pdf', 'Gizlilik.pdf'],
    leaveBalance: 20,
    allowedDevices: ['zk1', 'zk2'],
    nationalId: '10293847566',
    birthDate: '1988-05-12',
    gender: 'K',
    bloodType: 'A Rh+',
    address: 'Levent Mah. Çiçek Sok. No:5, Beşiktaş, İstanbul',
    emergencyContactName: 'John Connor',
    emergencyContactPhone: '+90 555 9988',
    deviceUserId: '1001'
  },
  {
    id: 'e2',
    firstName: 'Can',
    lastName: 'Yılmaz',
    email: 'can.y@nexus.com',
    phone: '+90 555 0102',
    departmentId: 'd1',
    unitId: 'u2',
    role: Role.USER,
    status: EmployeeStatus.PERMANENT,
    position: 'Backend Geliştirici',
    hireDate: '2021-03-10',
    salary: 72000,
    shiftId: 's1',
    clothingSize: 'L',
    documents: ['Sozlesme.pdf'],
    leaveBalance: 14,
    allowedDevices: ['zk1'],
    nationalId: '98765432101',
    birthDate: '1992-11-23',
    gender: 'E',
    bloodType: '0 Rh-',
    address: 'Kadıköy Cad. No:88, Göztepe, İstanbul',
    emergencyContactName: 'Mehmet Yılmaz',
    emergencyContactPhone: '+90 555 7766',
    deviceUserId: '1002'
  },
  {
    id: 'e3',
    firstName: 'Ayşe',
    lastName: 'Demir',
    email: 'ayse.d@nexus.com',
    phone: '+90 555 0103',
    departmentId: 'd2',
    unitId: 'u3',
    role: Role.MANAGER,
    status: EmployeeStatus.TEMPORARY,
    position: 'İK Uzmanı',
    hireDate: '2022-06-01',
    salary: 60000,
    shiftId: 's1',
    clothingSize: 'S',
    documents: [],
    leaveBalance: 8,
    allowedDevices: ['zk1'],
    nationalId: '55443322110',
    birthDate: '1995-02-15',
    gender: 'K',
    bloodType: 'B Rh+',
    address: 'Bağdat Cad. No:12, Maltepe, İstanbul',
    emergencyContactName: 'Fatma Demir',
    emergencyContactPhone: '+90 555 3322',
    deviceUserId: '1003'
  },
];

export const DEVICES: Device[] = [
  { id: 'zk1', name: 'Ana Giriş ZK-F12', ipAddress: '192.168.1.201', port: 4370, locationId: 'loc1', status: 'ONLINE', lastSync: '2023-10-27T08:30:00Z' },
  { id: 'zk2', name: 'Depo ZK-UA300', ipAddress: '192.168.1.205', port: 4370, locationId: 'loc2', status: 'OFFLINE', lastSync: '2023-10-26T18:00:00Z' },
];

export const ATTENDANCE_LOGS: AttendanceRecord[] = [
  { id: 'a1', employeeId: 'e1', deviceId: 'zk1', timestamp: '2023-10-27T08:55:00', type: 'ENTRY' },
  { id: 'a2', employeeId: 'e2', deviceId: 'zk1', timestamp: '2023-10-27T09:05:00', type: 'ENTRY' },
  { id: 'a3', employeeId: 'e1', deviceId: 'zk1', timestamp: '2023-10-27T18:05:00', type: 'EXIT' },
];

export const LEAVES: LeaveRequest[] = [
  { id: 'l1', employeeId: 'e2', type: LeaveType.ANNUAL, startDate: '2023-11-01', endDate: '2023-11-05', status: 'APPROVED', reason: 'Aile tatili' },
  { id: 'l2', employeeId: 'e3', type: LeaveType.SICK, startDate: '2023-10-20', endDate: '2023-10-21', status: 'APPROVED', reason: 'Grip' },
];

export const HOLIDAYS: Holiday[] = [
  { id: 'h1', name: 'Yılbaşı', date: '2024-01-01', type: 'PUBLIC', description: 'Yeni yıl kutlaması' },
  { id: 'h2', name: '23 Nisan Ulusal Egemenlik ve Çocuk Bayramı', date: '2024-04-23', type: 'PUBLIC', description: 'TBMM açılış yıldönümü' },
  { id: 'h3', name: 'Şirket Kuruluş Günü', date: '2024-09-15', type: 'CORPORATE', description: 'Nexus kuruluş yıldönümü' },
  { id: 'h4', name: 'Cumhuriyet Bayramı', date: '2024-10-29', type: 'PUBLIC' },
];
